import React, { useState, useEffect } from "react";
import SaveButtonWithModal from "./SaveButtonWithModel";
const BackgroundInfoSection = ({
  languages,
  languages1,
  selected,
  setSelected,
  selected1,
  setSelected1,
  erfNumber,
  setErfNumber,
  onSave,
  showError,
}) => {
  const [error, setError] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const [landSizes, setLandSizes] = useState({
    "Community allocation ": { size: "", unit: "" },
    "Residential": { size: "", unit: "" },
    "Road side vacant land": { size: "", unit: "" },
    "Village / Local/ Tribunal Authority allocation": { size: "", unit: "" }
  });
  const [isErfFocused, setIsErfFocused] = useState(false);

  useEffect(() => {
    if (showError) {
      validateSection();
    }
  }, [showError]);

  useEffect(() => {
    if (selected || selected1 || erfNumber) {
      setError("");
    }
  }, [selected, selected1, erfNumber]);

  useEffect(() => {
    const landData = {
      type1: selected ? { 
        type: selected, 
        size: landSizes[selected]?.size || "", 
        unit: landSizes[selected]?.unit || "",
        hasLandSize: !!landSizes[selected]?.size 
      } : null,
      type2: selected1 ? { 
        type: selected1, 
        size: landSizes[selected1]?.size || "", 
        unit: landSizes[selected1]?.unit || "",
        hasLandSize: !!landSizes[selected1]?.size 
      } : null,
      erfNumber
    };
    
    onSave(landData);
  }, [selected, selected1, landSizes, erfNumber]);

  const validateSection = () => {
    if (!selected && !selected1 && !erfNumber) {
      setError("This section is required. Please select at least one land type or enter an ERF number.");
      return false;
    }
    setError("");
    return true;
  };

  const handleSizeChange = (type, e) => {
    const value = e.target.value;
    setLandSizes(prev => ({
      ...prev,
      [type]: {
        ...prev[type],
        size: value
      }
    }));
  };

  const handleErfChange = (e) => {
    setErfNumber(e.target.value);
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const incrementSize = (type) => {
    const currentSize = landSizes[type]?.size || "0";
    const newSize = parseInt(currentSize) + 1;
    setLandSizes(prev => ({
      ...prev,
      [type]: {
        ...prev[type],
        size: newSize.toString()
      }
    }));
  };

  const decrementSize = (type) => {
    const currentSize = landSizes[type]?.size || "0";
    const newSize = Math.max(0, parseInt(currentSize) - 1);
    setLandSizes(prev => ({
      ...prev,
      [type]: {
        ...prev[type],
        size: newSize.toString()
      }
    }));
  };

  return (
    <div>
      {/* Header with toggle button - Mobile changes only */}
      <div 
        className="w-full md:h-[88px] h-[40px] flex items-center justify-between  bg-[#152C24] rounded-[10px] md:mt-7 mt-3 relative cursor-pointer"
        onClick={toggleExpand}
      >
        <div className="w-[154px] h-[40px] sm:w-[100px] sm:h-[100px]"></div>
        <div className="absolute md:text-[32px] text-[8px] text-left  md:px-6 px-2  text-white font-bold">
          LAND
        </div>
        <div className="md:w-[154px] md:h-[88px] w-[100px] h-[40px] bg-[#D9D9D9] rounded-r-[10px] flex items-center justify-center border-b border-black">
          <img
            src={`https://res.cloudinary.com/dzngpgki4/image/upload/${
              isExpanded 
                ? 'v1748785688/Expand_down_yilqh4.png' 
                : 'v1748785688/Expand_down_yilqh4.png'
            }`}
            alt="expand icon"
            className="md:w-12 md:h-12 w-4 h-4"
          />
      
        </div>
      </div>

      {/* Collapsible content - Mobile changes only */}
      {isExpanded && (
        <div className="animate-fadeIn">
          <div className="md:mt-3 mt-4">
            <h1 className="md:text-[24px] text-[12px] font-medium text-center italic">Land designated for agricultural use</h1>
            <p className="md:text-[24px] italic font-medium text-[8px]  md:pl-2 md:mt-6 mt-1">
              Enter/type the size of Land and click
            </p>
          </div>
          
          {error && (
            <div className="text-red-600 text-[12px] md:text-xs mb-2 text-center">{error}</div>
          )}

          <div className="grid grid-cols-2 md:gap-1 gap-3 md:mt-4 mt-4">
            <div className="grid grid-cols-1 md:gap-3 gap-2">
              {languages.map((lang, i) => {
                const isActive = selected === lang;
                const isFoodGarden = lang.includes(" allocation");
                const [mainLabel, subLabel] = isFoodGarden
                  ? ["Community", " allocation"]
                  : [lang, ""];
                return (
                  <div key={i} className="w-full">
                    <button
                      onClick={() => setSelected(lang)}
                      disabled={lang === "-"}
                      className="flex items-center justify-between w-full md:h-[72px] h-[40px] bg-[#CFD7D7] border border-[#E7EBEB] rounded-[5px]"
                    >
                      <div className="bg-[#CFD7D7] h-full md:w-[380px] w-[60%] text-left flex flex-col justify-center md:pl-6 pl-2">
                        <span className="font-bold md:text-[20px] text-[8px] leading-tight">
                          {mainLabel}
                        </span>
                        {subLabel && (
                          <span className="font-bold md:text-[20px] text-[4px]">
                            {subLabel}
                          </span>
                        )}
                      </div>
                      <div className="flex">
                        <div className="flex items-center md:gap-1 gap-2 md:ml-0 -ml-10 pr-2 md:px-12">
                          <input
                            type="number"
                            placeholder="1"
                            value={isActive ? landSizes[lang]?.size || "" : ""}
                            onChange={(e) => handleSizeChange(lang, e)}
                            className="bg-transparent text-black bg-[#CFD7D7] placeholder-black md:text-[24px] text-[8px] outline-none border-none text-center font-normal w-12 md:w-24 focus:outline-none"
                          />
                          <div className="flex flex-col items-center justify-center">
                            <button 
                              onClick={(e) => {
                                e.stopPropagation();
                                incrementSize(lang);
                              }}
                              className="w-3 h-3 flex items-center justify-center"
                            >
                            </button>
                            <button 
                              onClick={(e) => {
                                e.stopPropagation();
                                decrementSize(lang);
                              }}
                              className="w-3 h-3 flex items-center justify-center"
                            >
                            </button>
                          </div>
                          <h1 className="md:text-[24px] text-[8px] text-black font-normal ml-1">Ha</h1>
                        </div>
                        <div className="md:w-[100px] w-[40px] flex justify-center items-center  md:h-[72px] h-[40px] bg-[#E7EBEB]">
                          <div 
                            className={`w-5 h-5 md:w-14 md:h-14 rounded-full 
                              ${
                                isActive
                                  ? "bg-[#2E453D] md:border-[8px] border-[4px] border-white"
                                  : "md:border-[8px] border-[4px] border-white bg-[#D9D9D9]"
                              }`}>
                          </div>
                        </div>
                      </div>
                    </button>
                  </div>
                );
              })}
            </div>
            
            <div className="grid grid-cols-1 md:gap-[12px] gap-2">
              {languages1.map((lang, i) => {
                const isActive = selected1 === lang;
                let mainLabel = lang;
                let subLabel = "";
                if (lang.includes("vacant land")) {
                  mainLabel = "Road side";
                  subLabel = "vacant land";
                } else if (lang.includes("Authority allocation")) {
                  mainLabel = "Village Local/ Tribunal ";
                  subLabel = "Authority allocation";
                }
                return (
                  <div key={i} className="w-full">
                    <button
                      onClick={() => setSelected1(lang)}
                      disabled={lang === "-"}
                      className="flex items- center justify-between w-full md:h-[72px] h-[40px] bg-[#CFD7D7] border border-[#E7EBEB] rounded-[5px]"
                    >
                      <div className="bg-[#CFD7D7] h-full text-left flex flex-col justify-center md:pl-6 pl-2">
                        <span className="font-bold md:text-[20px]  md:w-[240px] text-[8px] leading-tight">
                          {mainLabel}
                        </span>
                        {subLabel && (
                          <span className="font-bold md:text-[20px] text-[4px]">
                            {subLabel}
                          </span>
                        )}
                      </div>
                      <div className="flex">
                        <div className="flex items-center  md:px-6 md:gap-1 gap-2 md:ml-0 -ml-10 pr-2">
                          <input
                            type="number"
                            placeholder="1"
                            value={isActive ? landSizes[lang]?.size || "" : ""}
                            onChange={(e) => handleSizeChange(lang, e)}
                            className="bg-transparent text-black bg-[#CFD7D7] placeholder-black md:text-[24px] text-[8px] outline-none border-none text-center font-normal w-12 md:w-24 focus:outline-none"
                          />
                          <div className="flex flex-col items-center justify-center">
                            <button 
                              onClick={(e) => {
                                e.stopPropagation();
                                incrementSize(lang);
                              }}
                              className="w-3 h-3 flex items-center justify-center"
                            >
                            </button>
                            <button 
                              onClick={(e) => {
                                e.stopPropagation();
                                decrementSize(lang);
                              }}
                              className="w-3 h-3 flex items-center justify-center"
                            >
                            </button>
                          </div>
                          <h1 className="md:text-[24px] text-[8px] text-black font-normal ml-1">Ha</h1>
                        </div>
                        <div className="md:w-[100px] w-[40px] flex justify-center items-center  md:h-[72px] h-[40px] bg-[#E7EBEB]">
                          <div 
                            className={`w-5 h-5 md:w-14 md:h-14 rounded-full 
                              ${
                                isActive
                                  ? "bg-[#2E453D] md:border-[8px] border-[4px] border-white"
                                  : "md:border-[8px] border-[4px] border-white bg-[#D9D9D9]"
                              }`}>
                          </div>
                        </div>
                      </div>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
          
          <div className="h-[1px] bg-[#919291] my-4 md:mt-5 md:mb-5"></div>

          <div className="flex md:mt-6 mt-4 w-full md:h-[72px] h-[40px] border-black border-b-[2px] bg-[#E7EBEB] rounded-[5px]">
            <div className="w-[40%] md:w-1/2 bg-[#CFD7D7] flex items-center md:pl-6 pl-2">
              <span className="font-bold md:text-[32px] text-[8px] leading-tight">
                LAND REGISTRATION NUMBER
              </span>
            </div>
            <div className="w-[60%] md:w-1/2 flex items-center justify-center pr-2">
              <input
                type="text"
                value={erfNumber || ""}
                onChange={handleErfChange}
                onFocus={() => setIsErfFocused(true)}
                onBlur={() => setIsErfFocused(false)}
                placeholder={!isErfFocused && !erfNumber ? "xxxxxxxxxx" : ""}
                className="bg-transparent text-black text-left placeholder:text-black font-medium border-[#E7EBEB] w-full md:text-[32px] text-[8px] focus:outline-none px-4"
              />
            </div>
          </div>

          <SaveButtonWithModal />
        </div>
      )}
    </div>
  );
};

export default BackgroundInfoSection;